import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${spacing(1.5)};
`;

export const $FileHeader = styled.div`
  flex: 1;
  ${fontStyle('lg')};
  color: ${({ theme }) => theme.newUI.defaultColors.heading};
`;

export const $Divider = styled.div`
  width: 100%;
  height: ${spacing('px')};
  background: ${({ theme }) => theme.colors.lightGrey};
  margin: ${spacing('xs')} 0 ${spacing('xs')};
`;

export const $CollapsableButton = styled.div`
  display: flex;
  align-items: center;
  z-index: 1;
  cursor: pointer;
`;

export const $ItemWrapper = styled.div`
  display: flex;
  padding: ${spacing(1.5)} ${spacing(1.5)};
  @media ${media.maxWidth.xs} {
    flex-direction: column;
  }
`;

export const $ItemDate = styled.div`
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  font-weight: ${fontWeight('normal')};
  @media ${media.maxWidth.xs} {
    margin-bottom: ${spacing('lg')};
  }

  white-space: nowrap;
`;

export const $ItemLabel = styled.span`
  color: ${({ theme }) => theme.newUI.defaultColors.text};
  font-weight: ${fontWeight('medium')};
  margin-bottom: ${spacing('sm')};
`;
